import styled from '@emotion/styled';
import theme from 'App.theme';
import Theme from 'App.theme';

const HEIGHT = 32;

export const Input = styled.input`
  display: flex;
  text-align: justify;
  letter-spacing: 1px;
  background-color: ${Theme.greys.GREY0};
  width: 100%;
  max-width: 82px;
  height: ${HEIGHT}px;
  text-align: center;
  border: none;
  outline: none;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    appearance: none;
  }
`;

export const IconDiv = styled.div<{ side: 'left' | 'right'; canMove: boolean }>(({ side, canMove }) => ({
  backgroundColor: canMove ? Theme.colors.black : Theme.greys.GREY2,
  borderTopLeftRadius: side == 'left' ? '50%' : 0,
  borderBottomLeftRadius: side == 'left' ? '50%' : 0,
  borderTopRightRadius: side == 'right' ? '50%' : 0,
  borderBottomRightRadius: side == 'right' ? '50%' : 0,
  width: `${HEIGHT}px`,
  height: `${HEIGHT}px`,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: theme.colors.white,
}));
